import React from 'react'

import FieldFormElement from "../../fields3/render/form-elemnent"
import FormFieldError from "../../gd-form/common/form-error/form-field-error"
import FormModel from "../../gd-form/common/form-model-manager"
import FormRowFlex from "../../gd-form/form/form-flex/row"
import {ItemIconSize} from "../../gd-components/icons/@const"
import SaveAsTemplateModel from "./save-as-template-model"

type Props = {
    form        : FormModel
    model       : SaveAsTemplateModel
    labelWidth  : number
    labelClass  : string
}

/**
 * The task type to create, shown under the dropdown while "Create new" is picked - the same three
 * fields TaskTypeSettings_General edits, over the modal's own model.
 */
export default function SaveAsTemplate_NewTaskTypeFields(props: Props) {

    const {form, model, labelWidth, labelClass} = props

    return (
        <>
            <FormRowFlex className   = "m-b-25"
                         label       = "Task type name"
                         width       = {labelWidth}
                         labelClass  = {labelClass}>
                <div className="flex-column-left-top">
                    <FieldFormElement className = "w-300"
                                      field     = {gd.fields.taskType.name}
                                      form      = {form}
                                      model     = {model}/>
                    <FormFieldError form={form} fieldId={gd.fields.taskType.name.fieldId}/>
                </div>
            </FormRowFlex>

            <FormRowFlex className   = "m-b-25"
                         label       = "Icon"
                         width       = {labelWidth}
                         labelClass  = {labelClass}>
                <FieldFormElement className = "w-60"
                                  field     = {gd.fields.taskType.icon}
                                  form      = {form}
                                  model     = {model}
                                  options   = {{size: ItemIconSize.SIZE_18}}/>
            </FormRowFlex>

            <FormRowFlex className   = "m-b-25"
                         label       = "Is Default"
                         width       = {labelWidth}
                         labelClass  = {labelClass}>
                <div className="flex-column-left-top">
                    <FieldFormElement className = "p-l-0"
                                      field     = {gd.fields.taskType.isDefault}
                                      form      = {form}
                                      model     = {model}/>

                    <div className="ui5-txt-not-important-small lh-14em m-t-10 w-300">
                        If enabled, this task type will automatically be available in all projects and
                        folders. Otherwise, it must be enabled manually for specific folders.
                    </div>
                </div>
            </FormRowFlex>
        </>
    )
}
